import * as React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation, DialogProps } from '~shared/components/Dialog';

export interface Props extends Pick<DialogProps, 'open' | 'onClose'> {
  onOkay: () => void;
}

export function DeleteEmptyQuizDialog({ open, onClose, onOkay }: Props) {
  return (
    <DialogConfirmation
      id="delete-empty-quiz"
      open={open}
      title={translate('Incomplete Quiz')}
      onClose={onClose}
      closeLabel={translate('Close')}
      actions={[
        <UIButton key="yes" appearance="primary" onClick={onOkay}>
          {translate('Yes')}
        </UIButton>,
        <UIButton key="no" onClick={onClose}>
          {translate('No')}
        </UIButton>,
      ]}
    >
      {translate(
        'A quiz must have at least one question. Would you like to delete this quiz?'
      )}
    </DialogConfirmation>
  );
}
